<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont1">{{$t('viewCertificate.queryingCertificate')}}</span>
    </p>
    <el-row style="top: 17px">
      <el-col :span="22" :offset="1">
        <el-table           
          :data="queryCertificateData"
          v-loading="pageLoading"
          style="width: 100%; margin-bottom: 75px">
          <!-- 名称 -->
          <el-table-column
            prop="definitionName"
            :label="$t('viewCertificate.name')"
            align="left"
            min-width="80"
            >
          </el-table-column>
          <!-- 模板 -->
          <el-table-column
            :label="$t('viewCertificate.template')"
            align="left"
            min-width="40"
            >
            <template slot-scope="scope">
              <el-button @click="display(scope.row, scope.$index)" type="text">{{$t('viewCertificate.display')}}</el-button>
              <div style="display: none;">
                <el-image
                  :ref="'templateImgRef' + scope.$index"
                  class="img-layout"
                  :src="scope.row.imagePath"
                  :preview-src-list="srcList[scope.$index]"
                  fit="fill"
                  >
                </el-image>
              </div>
            </template>
          </el-table-column>
          <!-- 关联课程 -->
          <el-table-column
            prop="relatedCourses"
            :label="$t('viewCertificate.associateCourse')"
            align="left"
            min-width="136"
            >
            <template slot-scope="scope">
              <el-row v-if="scope.row.relatedCourses != null">
                <span v-for="(item, index) in scope.row.relatedCourses.split(',')" :key="index" style="white-space: pre-wrap;">{{item}}</span>
              </el-row>
            </template>
          </el-table-column>
          <!-- 发证方式 -->
          <el-table-column
            prop="issuanceMethod"
            :label="$t('viewCertificate.authenticationMethod')"
            align="left"
            min-width="50"
            >
            <template slot-scope="scope">
            <span v-if="scope.row.issuanceMethod == 1">{{$t('certificateManagement.aCourse')}}</span>
            <span v-if="scope.row.issuanceMethod == 2">{{$t('certificateManagement.multipleCourses')}}</span>
          </template>
          </el-table-column>
          <!-- 上次编辑 -->
          <el-table-column
            :formatter="dateAndTimeFormat"
            prop="updateTime"
            :label="$t('viewCertificate.lastEdited')"
            align="left"
            min-width="70"
            >
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            min-width="50"
            >
            <template slot-scope="scope">
              <el-button @click="edit(scope.row)" type="text">{{$t('common.edit')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <el-row style="text-align: right; margin: 20px">
      <el-col :span="24">
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-row><br /><br /></el-row>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
export default {
  data() {
    return {
      // 上课邀请一览数据
      queryCertificateData: [],
      // 页面载入状态
      pageLoading: false,
      // 当前页
      currentPage: 1,
      // 每页件数
      pageSize: 20,
      total: 0,
      // 证书模板预览大图Url
      srcList: [],
      //证书图片
      imageShow: false,
    }
  },
  mounted() {
    if(sessionStorage.getItem('detailReturn')){
      this.ReturnOoriginalPage()
    }else{
      this.init(true);
    }
  },
  methods: {
    // 初始化查询证书一览数据
    init(val) {
      this.pageLoading = true;
      if (val) {
      this.currentPage = 1;
      this.total =0;
    }
      let url = "/api/viewCertificate/queryCertificate"
      this.$http
        .post(url,
          qs.stringify({
            currentSize: (this.currentPage - 1) * this.pageSize,
            pageSize: this.pageSize,
            total: this.total,
          })
        )
        .then((response) => {
          if (response.data.code === 200) {
            this.queryCertificateData = response.data.data
            // console.log("response.data.data",response.data.data)
            // for(let i=0;i<response.data.data.length;i++){
            //   if(this.queryCertificateData[i].relatedCourses!=null){
            //     let str = this.queryCertificateData[i].relatedCourses.replaceAll(',',',\n')
            //     this.queryCertificateData[i].relatedCourses=str
            //   }
            // }
            if(response.data.data!=null){
              for(let i=0;i<response.data.data.length;i++){
                if(this.queryCertificateData[i].relatedCourses!=null){
                  var relatedCoursesStr = this.queryCertificateData[i].relatedCourses.split(',')
                  let str = ""
                  for(let j=0;j<relatedCoursesStr.length;j++){
                    str = str + relatedCoursesStr[j] + ",\n"
                  }
                  this.queryCertificateData[i].relatedCourses=str
                }
              }
            }
            // 证书模板预览大图Url
            if(response.data.data!=null){
              this.srcList=[]
              this.queryCertificateData.forEach((element) => {
                this.srcList.push([element.imagePath])
              });
              this.total=this.queryCertificateData[0].total;
            }
            this.pageLoading = false;
          } else {
            this.pageLoading = false;
            this.$message.error(response.data.message)
          }
        })
        .catch((err) => {
          console.log(err)
          this.pageLoading = false;
          this.$message.error(this.$t('common.anErrorOccurred'))
        });
    },
    //格式化时间
    dateAndTimeFormat(row) {
      if(row.updateTime!=null&&row.updateTime!=""){
        return moment(row.updateTime).format("YYYY-MM-DD HH:mm");
      }
    },
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      //判断更改页码是否需要查询
      if (
        this.queryCertificateData == undefined ||
        this.queryCertificateData.length <= 0
      ) {
        return;
      }
      this.init(false);
      console.log(`每页 ${val} 条`);
    },
    // 当前页显示
    handleCurrentChange(val) {
      this.currentPage = val;
      this.init(false);
      console.log(`当前页: ${val}`);    
    },
    // 预览证书的中英文模板
    display(row, index){
      this.$refs['templateImgRef' + index].clickHandler()
    },
    // 编辑按钮
    edit(row) {
      let p0342 =JSON.stringify({
        definitionName: row.definitionName,
      });
      sessionStorage.p0342 = p0342
      sessionStorage.setItem("totalCertificate",this.total)
      sessionStorage.setItem("pageSizeCertificate",this.pageSize)
      sessionStorage.setItem("currentPageCertificate",this.currentPage)
      this.$router.push({
          path: "/views/GreenJacketForum/P0343",
      });
    },
    // 编辑证书画面返回原页面
    ReturnOoriginalPage(){ //当从详情页返回的时候，先获取详情页中存下来的detall标识，在列表页中，把获取到的分页页码重新赋值，用以返回前的页面，保持不变
      if(sessionStorage.getItem('detailReturn')){
        //如果有这个就读取缓存里面的数据
      this.currentPage=Number(sessionStorage.getItem("currentPageCertificate"));
      this.total = Number(sessionStorage.getItem("totalCertificate"));
      this.pageSize = Number(sessionStorage.getItem("pageSizeCertificate"));
      this.init(false);
      sessionStorage.removeItem("detailReturn");
      sessionStorage.removeItem("currentPageCertificate");
      sessionStorage.removeItem("totalCertificate");
      sessionStorage.removeItem("pageSizeCertificate");
      }else{
        this.currentPage=1;
        //这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
        sessionStorage.removeItem("currentPageCertificate");
        sessionStorage.removeItem("totalCertificate");
      }
    },
  },
}
</script>

<style lang="scss" scoped>

>>>.el-table thead{
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  color: #333333;
  font-size: 16px;
}

>>>.el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170)
}

>>>.el-table__row {
  height: 42px;
}

>>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>>.el-table--border::after, .el-table--group::after, .el-table::before{
  background: none;
}
</style>


// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0342.vue